module.exports = "/_next/static/images/TailoredProduct@2x-37bee07db2476a03bc1b1101446a6739.png";